// Module-level singleton holding the resolved theme for the current page load.
//
// There is exactly one partner (or the default house brand) per page load, so a
// simple module variable is the right shape. It is populated once during
// bootstrap (src/theme/partnerTheme.js) BEFORE React renders, which lets both
// React consumers (ThemeContext) and non-React consumers (utils/markerIcon)
// read the same resolved values without prop drilling.

import defaultTheme from './defaultTheme';

let resolvedTheme = defaultTheme;

export const getResolvedTheme = () => resolvedTheme;

export const setResolvedTheme = (theme) => {
  resolvedTheme = theme && typeof theme === 'object' ? theme : defaultTheme;
  return resolvedTheme;
};

export default getResolvedTheme;
